import React from 'react'
import PropTypes from 'prop-types'
import { CollapsibleText } from 'LiveBoard/components/shared/CollapsibleText'
import get from 'lodash/get'

import './style.css.scss'

const MAX_CHARACTERS_DESCRIPTION_MOBILE = 85

class Header extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const item = this.props.item
    const classicVideoClassName = this.props.isVideoItem && !this.props.isClassicTheme
      ? 'below-content'
      : ''

    return (
      <section
        className={`header-wrapper ${classicVideoClassName}`} >
        {
          item.category_name && !this.props.isClassicTheme &&
          <p className="item-category">
            {item.category_name || ""}
          </p>
        }
        <h1>{item.name}</h1>
        { !this.props.isClassicTheme &&
          <CollapsibleText
            classNames={{
              container: "item-description-container" ,
              text: "item-description"
            }}
            text={item.description}
            themeColorHex={this.props.themeColorHex}
            maxCharacters={MAX_CHARACTERS_DESCRIPTION_MOBILE} />
        }
      </section>
    )
  }
}

Header.propTypes = {
  item: PropTypes.object.isRequired,
  isVideoItem: PropTypes.bool,
  themeColorHex: PropTypes.string,
  isClassicTheme: PropTypes.bool
}

export default Header